import { useCallback } from 'react';
import { store } from 'Utilities/store';
import { getConnectionsService, sharingCodeValidateService } from 'Services/libre_api';
const useLibreConnection = () => {
  const getConnections = useCallback(async () => {
    const {
      user
    } = store.getState().auth;
    const {
      osType,
      osVersion,
      app,
      appVersion
    } = store.getState().env;
    const connections = await getConnectionsService(user.id, osType, osVersion, app, appVersion);
    return connections;
  }, []);
  const sharingCodeValidate = useCallback(async (code, yearOfBirth) => {
    const {
      user
    } = store.getState().auth;
    const {
      osType,
      osVersion,
      app,
      appVersion
    } = store.getState().env;
    await sharingCodeValidateService(code, yearOfBirth, user.id, osType, osVersion, app, appVersion);
  }, []);
  return {
    getConnections,
    sharingCodeValidate
  };
};
export default useLibreConnection;